/**
 * Empty chart fixtures — chart content comes from Medplum (`medplumChartBundle`, episode-scoped hooks).
 */
import type {
  Appointment,
  Assessment,
  AssessmentDataPoint,
  ClientDocument,
  CompletedForm,
  DischargeSummary,
  Episode,
  Medication,
  NoteSnippet,
  NoteTemplate,
  OutstandingForm,
  ProviderAssociation,
  Task,
  TreatmentPlan,
} from './types';

export const mockAppointments: Appointment[] = [];
export const mockProviderAssociations: ProviderAssociation[] = [];
export const mockTreatmentPlans: TreatmentPlan[] = [];
export const mockEpisodes: Episode[] = [];
export const mockDischargeSummaries: DischargeSummary[] = [];
export const mockAssessments: Assessment[] = [];
export const mockOutstandingForms: OutstandingForm[] = [];
export const mockTasks: Task[] = [];
export const mockAssessmentTrends: AssessmentDataPoint[] = [];
export const mockCompletedForms: CompletedForm[] = [];
export const mockClientDocuments: ClientDocument[] = [];
export const availableFormTypes: string[] = [];
export const mockMedications: Medication[] = [];
export const mockNoteTemplates: NoteTemplate[] = [];
export const mockNoteSnippets: NoteSnippet[] = [];
